import type { FC } from "react";
import { Icon } from "../UI/Icon";

interface StoreIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export const StoreIcon: FC<StoreIconProps> = (props) => (
  <Icon {...props} variant="outline" viewBox="0 0 16 16">
    <path
      d="M10.4163 0L10.4837 0.00390625C10.6405 0.0232763 10.7829 0.109415 10.8724 0.242188L13.2689 3.79883C13.3301 3.88964 13.3626 3.99694 13.3626 4.10645V13.5898C13.3626 13.8936 13.1166 14.1396 12.8128 14.1396H1.54622C1.24248 14.1396 0.99644 13.8936 0.996419 13.5898V4.10645C0.996424 3.99694 1.02898 3.88964 1.09017 3.79883L3.48665 0.242188L3.52865 0.188477C3.63231 0.0696117 3.78281 5.27994e-05 3.94271 0H10.4163ZM2.09603 4.27441V13.04H12.263V4.27441L10.1234 1.09961H4.23568L2.09603 4.27441Z"
      fill="currentColor"
    />
    <path
      d="M10.1133 13.5902V9.1263H4.24609V13.5902C4.24591 13.8938 3.99993 14.14 3.69629 14.14C3.39265 14.14 3.14667 13.8938 3.14648 13.5902V8.5765C3.14648 8.27274 3.39253 8.02669 3.69629 8.02669H10.6631C10.9668 8.02676 11.2129 8.27278 11.2129 8.5765V13.5902C11.2127 13.8937 10.9667 14.1399 10.6631 14.14C10.3594 14.14 10.1135 13.8938 10.1133 13.5902Z"
      fill="currentColor"
    />
    <path
      d="M10.9967 6.02669C11.3003 6.02694 11.5465 6.27289 11.5465 6.5765C11.5465 6.8801 11.3003 7.12606 10.9967 7.1263H3.36296C3.0592 7.1263 2.81315 6.88025 2.81315 6.5765C2.81315 6.27274 3.0592 6.02669 3.36296 6.02669H10.9967Z"
      fill="currentColor"
    />
    <path
      d="M13.8096 3.55664C14.1133 3.55664 14.3594 3.80269 14.3594 4.10645C14.3594 4.4102 14.1133 4.65625 13.8096 4.65625H0.549805C0.246048 4.65625 0 4.4102 0 4.10645C0 3.80269 0.246048 3.55664 0.549805 3.55664H13.8096Z"
      fill="currentColor"
    />
    <path
      d="M13.8096 13.04C14.1133 13.04 14.3594 13.2861 14.3594 13.5898C14.3594 13.8936 14.1133 14.1396 13.8096 14.1396H0.549805C0.246048 14.1396 0 13.8936 0 13.5898C0 13.2861 0.246048 13.04 0.549805 13.04H13.8096Z"
      fill="currentColor"
    />
    <path
      d="M6.62988 13.59V8.73649C6.62988 8.43273 6.87593 8.18669 7.17969 8.18669C7.48344 8.18669 7.72949 8.43273 7.72949 8.73649V13.59C7.72939 13.8937 7.48338 14.1398 7.17969 14.1398C6.87599 14.1398 6.62998 13.8937 6.62988 13.59Z"
      fill="currentColor"
    />
  </Icon>
);
